import type {Page, Result, UseCase} from 'framework';
import type {WorkoutError} from '../../domain/errors';
import type {WorkoutTemplateSummary} from '../../domain/workout-template';
import type {WorkoutRepository} from '../ports/workout.repository';

export type ListWorkoutTemplatesInput = {
  readonly cursor: string | null;
  readonly q: string;
};

export class ListWorkoutTemplates implements UseCase<
  [ListWorkoutTemplatesInput],
  Page<WorkoutTemplateSummary>
> {
  constructor(private readonly repository: WorkoutRepository) {}

  execute(
    input: ListWorkoutTemplatesInput,
  ): Promise<Result<Page<WorkoutTemplateSummary>, WorkoutError>> {
    return this.repository.listTemplates(input);
  }
}
